function HouseMindMark() {
  return (
    <svg viewBox="0 0 80 80" width="18" height="18" aria-hidden="true">
      <polyline
        points="12,42 40,16 68,42"
        fill="none"
        stroke="white"
        strokeWidth="8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M38,37C38,37 28,35 26,41C24,45 26,49 28,51C26,53 25,57 27,60C29,63 33,64 36,63C37,64 38,65 40,65L40,37Z" fill="white" />
      <path d="M42,37C42,37 52,35 54,41C56,45 54,49 52,51C54,53 55,57 53,60C51,63 47,64 44,63C43,64 42,65 40,65L40,37Z" fill="white" />
    </svg>
  );
}

export function SheetLogoRow({ title, onClose, closeLabel = "Close", actions = null, showClose = true }) {
  return (
    <div className="hm-sheet-logo-row">
      <div className="hm-sheet-brand">
        <div className="hm-sheet-logo-ico">
          <HouseMindMark />
        </div>
        <span className="hm-sheet-title">{title}</span>
      </div>
      <div className="hm-sheet-controls">
        {actions}
        {showClose && (
          <button type="button" className="hm-sheet-close" onClick={onClose} aria-label={closeLabel}>
            ×
          </button>
        )}
      </div>
    </div>
  );
}

export default function SheetChrome({
  title,
  onClose,
  children,
  footer,
  handleRef,
  handleProps = {},
  bodyClassName = "",
}) {
  return (
    <>
      <div className="hm-sheet-top-row">
        <button
          ref={handleRef}
          type="button"
          className="hm-sheet-handle"
          aria-label={`Close ${title}`}
          {...handleProps}
        />
        <button type="button" className="hm-sheet-top-close" onClick={onClose} aria-label={`Close ${title}`}>
          ×
        </button>
      </div>
      <SheetLogoRow title={title} onClose={onClose} closeLabel={`Close ${title}`} showClose={false} />
      <div className={`hm-sheet-body${bodyClassName ? ` ${bodyClassName}` : ""}`}>
        {children}
      </div>
      {footer && <div className="hm-sheet-foot">{footer}</div>}
    </>
  );
}
